import {withRouterApi} from '../../../HOCs/withRouterApi';
import {FormViewProps} from '../../../@types/components/FormViewProps';
import {IEmptyModel} from '../../../@interfaces/IEmptyModel';
import {FormView} from './FormView';
import React from 'react';

const forceUrlParams = {id: 'create'};

export class CreateView<FormModel extends IEmptyModel = IEmptyModel> extends FormView<FormModel> {
    static defaultProps: Partial<React.ComponentProps<typeof CreateView>> = {
        forceUrlParams,
    };

    protected getUrlParams() {
        return {...super.getUrlParams(), id: 'create'};
    }
}

export default CreateView.getStoreConnector()(withRouterApi<FormViewProps>(CreateView));
